<div class="validation-summary" *ngIf="validationMessages?.length > 0">
    <ul>
        <li *ngFor="let validationMessage of validationMessages" (click)="addAnchorNavigation ? navigateToId(validationMessage.elementId) : ''">
            {{validationMessage.message}}
        </li>
    </ul>
</div>
